export default __webpack_public_path__ + "static/media/seo-monitoring.0ca26d71.svg";